<template>
  <div>
    <!-- banner -->
    <div class="serve-banner">
      <img src="../../assets/images/banner4.png" alt />
      <!-- <div class="serve_warp">
                <div class="top-text">
                    <p>服务支持</p>
                    <p>能够给予用户准确、明晰、简介的使用指导和说明</p>
                </div>
                <img src="" alt="">
      </div>-->
    </div>

    <div class="serve">
      <!-- 面包屑 -->
      <!-- <Breadcrumb separator=">" class="nav_rot">
                <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
                <Breadcrumb-item>服务支持</Breadcrumb-item>
      </Breadcrumb>-->

      <!-- 服务内容 -->
      <div class="serve-main">
        <!-- 左侧内容 -->
        <!-- <Collapse active-key="1" accordion class="ser_updown">
                    <Panel key="1" id="list_left" class="active-ser">
                        <span>操作视频</span>
                    </Panel>
                    <Panel key="2" id="list_left">
                        <span>使用手册</span>
                    </Panel>
                    <Panel key="3" id="list_left">
                        <span>问题解答</span>
                    </Panel>
        </Collapse>-->
        <div class="left_serve">
          <p class="title_li">服务支持</p>
          <ul>
            <li id="tabs-list" class="active-list">操作视频</li>
            <li id="tabs-list">使用手册</li>
            <li id="tabs-list">问题解答</li>
          </ul>
        </div>

        <!-- 右侧内容 -->
        <div class="ser_cards">
          <!-- 操作视频内容 -->
          <Row id="ser_allcont" class="row_all">
            <div class="col-cards">
              <div class="text_sercard">
                <img src="../../assets/images/78.png" alt />
                <p>VDMS-T-1 软件配置说明 Final</p>
                <span class="btn_down">
                  <a href="/static/down/01.mp4" download="VDMS-T-1 软件配置说明 Final.mp4">下载</a>
                </span>
              </div>
            </div>
            <div class="col-cards">
              <div class="text_sercard">
                <img src="../../assets/images/78.png" alt />
                <p>VDMS-T-1 硬件连接说明</p>
                <span class="btn_down">
                  <a href="/static/down/02.mp4" download="VDMS-T-1 硬件连接说明.mp4">下载</a>
                </span>
              </div>
            </div>
            <div class="col-cards">
              <div class="text_sercard">
                <img src="../../assets/images/78.png" alt />
                <p>VDMS-T-1 Hardware Connection Guide</p>
                <span class="btn_down">
                  <a href="/static/down/03.mp4" download="VDMS-T-1 Hardware Connection Guide.mp4">下载</a>
                </span>
              </div>
            </div>
          </Row>

          <!-- 使用手册内容 -->
          <Row id="ser_allcont" class="row_all hide">
            <div>
              <h1>VDMS系列</h1>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS客户端2.0用户说明手册</p>
                  <span class="btn_down">
                    <a href="/static/down/vdms2.pdf" download="VDMS客户端2.0用户说明手册.pdf">下载</a>
                  </span>
                </div>
              </div>

              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS客户端3.0用户说明手册</p>
                  <span class="btn_down">
                    <a href="/static/down/vdms3.pdf" download="VDMS客户端3.0用户说明手册.pdf">下载</a>
                  </span>
                </div>
              </div>
            
            </div>

            <div>
              <h1>T系列</h1>
                <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-T-1-A产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-T-1-A.pdf" download="VDMS-T-1-A产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
                <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-T-1-B产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-T-1-B.pdf" download="VDMS-T-1-B产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
                <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-T-4-A产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-T-4-A.pdf" download="VDMS-T-4-A产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-T-8产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-T-8.pdf" download="VDMS-T-8产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-T-1-HAB产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-T-1-HAB.pdf" download="VDMS-T-1-HAB产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
            </div>

            <div>
              <h1>MT系列</h1>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-MT-184视频处理服务器产品说明书 </p>
                  <span class="btn_down">
                    <a href="/static/down/MT-184.pdf" download="VDMS-MT-184视频处理服务器产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-MT-512 视频处理服务器产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/MT-512.pdf" download="VDMS-MT-512 视频处理服务器产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-MTG 产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-MTG.pdf" download="VDMS-MTG 产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
            </div>

            <div>
              <h1>GPU压缩服务器</h1>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-CA-1225HB产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-CA-1225HB.pdf" download="VDMS-CA-1225HB产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
               <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-CAS-2550HB产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-CAS-2550HB.pdf" download="VDMS-CAS-2550HB产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
               <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-CAS-75150HB产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-CAS-75150HB.pdf" download="VDMS-CAS-75150HB产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-CAS-50100HB产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-CAS-50100HB.pdf" download="VDMS-CAS-50100HB产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
            </div>

  <div>
              <h1>管理服务器</h1>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-CAMS-1225B产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-CAMS-1225B.pdf" download="VDMS-CAMS-1225B产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
            </div>

  <div>
              <h1>接收服务器</h1>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-T-200400B产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-T-200400B.pdf" download="VDMS-T-200400B产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>VDMS-TS-400800B产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/VDMS-TS-400800B.pdf" download="VDMS-TS-400800B产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
            </div>

            <div>
              <h1>其他</h1>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>NVR产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/nvr.pdf" download="NVR产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
              <div class="col-cards col-padding">
                <div class="text_sercard">
                  <img src="../../assets/images/pdf.png" alt />
                  <p>隐私相机产品说明书</p>
                  <span class="btn_down">
                    <a href="/static/down/yinsi.pdf" download="隐私相机产品说明书.pdf">下载</a>
                  </span>
                </div>
              </div>
            </div>
          </Row>

          <!-- 问题解答内容 -->
          <div id="ser_allcont" class="content_ser hide">
            <p class="first_p">常见问题</p>
            <Collapse active-key="1" style="margin-top: 20px; border: none;">
              <Panel key="1" active-key="1" class="ser-listd" style="border-top: 1px solid #ddd;">
                设备怎么接入视频监控系统？
                <div slot="content">
                  <div class="sertext_img">
                    <p>视频数据管理系统VDMS可以无缝对接视频监控系统，不改变原有视频架构。具体设备连接图需要具体项目提供视频监控系统的拓扑图来确定VDMS系统如何接入原有视频监控系统。</p>
                    <p>通用的接入方法如下：</p>
                    <p>（1）对于压缩设备，解决后端存储问题。VDMS设备接入到与视频管理平台同一个交换机上，一般是核心交换机。</p>
                    <img src="../../assets/images/39.png" alt />
                    <p>（2）对于传输设备，解决前端传输问题。VDMS设备接入到摄像机的接入交换机上。</p>
                    <img src="../../assets/images/42.png" alt />
                  </div>
                </div>
              </Panel>
              <Panel key="2" class="ser-listd">
                客户端怎么调用压缩后的视频？
                <div slot="content">
                  <div class="sq_list">
                    <p>2种方式调用压缩后的视频：</p>
                    <p>采用VDMS系统自带的客户端进行调用</p>
                    <p>采用第三方视频管理平台客户端调用，此种方式需要对接完成后使用。</p>
                  </div>
                </div>
              </Panel>
              <Panel key="3" class="ser-listd">
                转码之后的码流是原来码流的多少？
                <div slot="content">
                  <div class="sq_list">
                    <p>经过平台转码后，视频数据会成为标准的码流，大约是原始码流的1/4~1/5。</p>
                  </div>
                </div>
              </Panel>
              <Panel key="4" class="ser-listd">
                如何确定摄像机选型？
                <div slot="content">
                  <div class="sq_list">
                    <p>VDMS系统支持所有支持OnVif协议、国标GB/T28181协议的数字摄像机，包括海康、宇视、大华等主流品牌摄像机。</p>
                  </div>
                </div>
              </Panel>
              <Panel key="5" class="ser-listd">
                如何确定交换机型号？
                <div slot="content">
                  <div class="sq_list">
                    <p style="margin-bottom: 6px;">确定网口类型：</p>
                    <p>
                      取决于摄像机输入和视频输出带宽，经过VDMS处理后的带宽为原视频流带宽的1/10。
                      根据实际带宽需求确定需要的交换机网口类型。
                    </p>
                    <p style="margin-bottom: 6px; margin-top: 12px;">占用网口个数：</p>
                    <p>
                      系统中的设备提供多个千兆网口，其中VDMS系统中服务器设备占用1个网口，VDMS-T-1设备和摄像机直连模式下占用1个网口，
                      与摄像机通过交换机相连占用2个网口，客户端设备占用1个网口。
                    </p>
                  </div>
                </div>
              </Panel>
              <Panel key="6" class="ser-listd">
                如何对接视频管理平台？
                <div slot="content">
                  <div class="sq_list">
                    <p style="margin-bottom: 6px;">
                      视频数据管理系统VDMS能够跟主流厂商视频管理平台进行对接，包括海康、宇视、大华、天翼和科达等视频管理平台。
                      其中，有些厂商的非国标平台需要双方进行技术开发进行对接。因此，有如下两种对接方式：
                    </p>
                    <p>
                      ⦁ 国标对接：对于支持SIP服务GB/T28181协议的视频管理平台，不需要开发，直接配置即可。
                      由于国标规定视频只能以H.264编码进行传输，因此设备会将压缩编码转为标准编码，供视频管理平台调用。
                    </p>
                    <p>⦁ SDK对接：视频数据管理系统VDMS提供标准的SDK，由视频管理平台进行二次开发调用即可。</p>
                  </div>
                </div>
              </Panel>
              <Panel key="7" class="ser-listd">
                如何计算节省成本？
                <div slot="content">
                  <div class="sq_list">
                    <p>⦁ 存储节省的费用</p>
                    <p>总成本节约=传统方案存储-(VDMS设备+VDMS方案存储)</p>
                    <p>⦁ 带宽节省的费用</p>
                    <p>根据带宽运营商的传输费用计算节省的费用。</p>
                  </div>
                </div>
              </Panel>
              <Panel key="8" class="ser-listd">
                压缩倍率是针对什么视频的？
                <div slot="content">
                  <div class="sq_list">
                    <p>VDMS系统可以处理主流的视频格式，1/10的倍率是针对H.264编码的视频。</p>
                  </div>
                </div>
              </Panel>
              <Panel key="9" class="ser-listd">
                系统稳定性如何保障？
                <div slot="content">
                  <div class="sq_list">
                    <p>
                      VDMS系统在技术上通过分布式架构，以提高系统高容错性高扩展性；通过负载均衡，保证系统最大利用效率；
                      通过故障迁移，当设备出现问题时，任务自动迁移，保证系统稳定运行。
                    </p>
                    <p>在管理上，产品通过了公安一所严格的产品检测以及3c认证，公司通过了ISO9001认证；在服务上，我们有完整的售后服务体系。</p>
                  </div>
                </div>
              </Panel>
              <Panel key="10" class="ser-listd">
                视频清晰度是否受影响？
                <div slot="content">
                  <div class="sq_list">
                    <p>
                      VDMS系列产品是首家也是目前唯一在公安一所经过了检测的压缩比如此高的产品，并获得了检测报告。
                      检测报告中显示经过VDMS系统处理过后的视频，10倍压缩以后的PSNR值为37dB。
                    </p>
                    <p>
                      经过处理的视频符合目前对视频图像质量的评价标准——《数字视频安防监控系统基本技术要求》规定数字视频安防监控
                      系统的图像质量和技术指标应符合峰值信噪比（PSNR）不低32dB。该清晰度不影响二次处理和使用。
                    </p>
                  </div>
                </div>
              </Panel>
              <Panel key="11" class="ser-listd">
                智能分析都有什么？
                <div slot="content">
                  <div class="sq_list">
                    <p>
                      VDMS系统带有视频智能分析接口，可以加入智能分析服务。由于智能分析都是建立在深度学习基础之上，
                      所以需要根据项目需求和实际场景进行学习。下面举几个例子说明：
                    </p>
                    <p style="margin-top:10px;">目标检测-人流量统计（兼人数超额报警、脱岗报警）</p>
                    <p>
                      方案：人体检测，利用人体关键点检测技术统计某一时刻监控区域内出现的人员数目，若仅设置了人数统计功能，
                      仅返回得到的人员数目；若设置了超额报警功能，当统计的人员数目大于一定阈值时，发出人数超额报警。
                    </p>
                  </div>
                </div>
              </Panel>
            </Collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "../../../node_modules/jquery/dist/jquery.js";

import header from "../cuscom/header";
export default {
  mounted: function() {
    $(".left_serve #tabs-list").click(function() {
      $(".ser_cards #ser_allcont")
        .eq($(this).index())
        .removeClass("hide")
        .siblings()
        .addClass("hide");
      $(".left_serve #tabs-list:nth-child(1)").removeClass("active-list");
      $(".left_serve #tabs-list")
        .eq($(this).index())
        .addClass("active-list")
        .siblings()
        .removeClass("active-list");
    });
  },
  beforeRouteEnter: (to, from, next) => {
    next(vm => {
      window.scrollTo(0, 0);
    });
  }
};
</script>

<style>
/* 版心 */
.serve {
  width: 1200px;
  margin: 0 auto;
}
/* banner图 */
.serve-banner {
  width: 100%;
  /* height: 681px; */
}
.serve-banner img {
  width: 100%;
  height: 100%;
}

.serve_warp {
  position: absolute;
  top: 0px;
  left: 19%;
}
.top-text {
  width: 570px;
  position: absolute;
  top: 300px;
}
.top-text p:nth-child(1) {
  font-size: 40px;
  color: #ffffff;
}
.top-text p:nth-child(2) {
  font-size: 19px;
  color: #ffffff;
  margin-top: 10px;
}

/* 面包屑 */
.nav_rot {
  font-size: 18px;
  margin-top: 35px;
}
.ivu-breadcrumb-item-link {
  color: #333333;
}

/* 服务内容 */
.serve-main {
  width: 1200px;
  overflow: hidden;
  margin: 0 auto;
  background: #ffffff;
  margin-top: 100px;
  margin-bottom: 117px;
}

/* 等高布局 */
.left_serve,
.ser_cards {
  float: left;
}

/* 服务左侧内容 */
.left_serve {
  width: 222px;
  float: left;
}

.left_serve li {
  list-style: none;
  font-size: 18px;
  color: #333333;
  height: 50px;
  border-bottom: solid #dddddd 1px;
  line-height: 50px;
  padding-left: 23px;
  cursor: pointer;
  margin-top: 0px;
}
.left_serve li:nth-child(1) {
  border-top: 1px solid #dddddd;
}
.left_serve .title_li {
  font-size: 24px;
  padding: 0;
  margin-bottom: 10px;
}

.left_serve .active-list {
  color: #29b3de;
}

/* 右侧内容 */
.ser_cards {
  width: 957px;
  /* height: 720px; */
  background: #f2f2f2;
  word-break: break-all;
  padding-bottom: 2020px;
  margin-bottom: -2000px;
  margin-left: 8px;
  float: right;
  border: 1px solid #dddddd;
}

.hide {
  display: none;
}

/* 右侧卡片 */
.row_all {
  width: 780px;
  margin-left: 50px;
  margin-top: 25px;
}
.row_all h1 {
  margin: 10px 0;
}
.col-cards {
  height: 62px;
  width: 100%;
}

.text_sercard {
  width: 100%;
}
/* 卡片里图片 */
.text_sercard img {
  height: 50px;
  width: 50px;
  margin-top: 8px;
  float: left;
}
/* 卡片里的文字 按钮*/
.text_sercard p {
  float: left;
  font-size: 18px;
  color: #333333;
  margin-left: 75px;
  margin-top: 12px;
}
/* 按钮 */
.text_sercard .btn_down {
  width: 80px;
  height: 40px;
  text-align: center;
  display: block;
  font-size: 18px;
  color: #4088c8;
  text-decoration: underline;
  float: right;
  margin-top: 12px;
  cursor: pointer;
}

/* 问题内容 */
.content_ser {
  background: #f2f2f2;
  padding: 17px;
  /* margin-top: 55px; */
}
.col-padding {
  padding-left: 60px;
}
.first_p {
  color: #4088c8;
  font-size: 18px;
  text-shadow: 0 0 0.4px #4088c8;
  /* margin-left: 18px; */
}
.two_p {
  color: #333333;
  font-size: 18px;
  margin-top: 17px;
}

/* 问题中间内容 */
.sertext_img {
  height: 862px;
  background: #ffffff;
  padding: 5px;
}

.sertext_img p {
  color: #333333;
  font-size: 16px;
}
.sertext_img p:first-child {
  text-indent: 2em;
}

.sertext_img img {
  /* margin: 0 auto; */
  margin-top: 15px;
  margin-left: 137px;
  margin-bottom: 50px;
}

.sertext_img img:last-child {
  margin-left: 249px;
  margin-top: 43px;
}

.content_ser li {
  list-style: none;
  color: #333333;
  font-size: 18px;
  border-bottom: 1px solid #dddddd;
  margin-top: 13px;
}

/* 右侧问题折叠面板 */
.ser-listd {
  color: #333333;
  font-size: 18px;
  background: #f2f2f2;
}

.ser-listd:hover {
  background: #f2f0f0;
}

.ser-listd .ivu-icon {
  display: none;
}
.ser-listd .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
  padding-left: 0;
}

.sq_list p {
  font-size: 16px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/serve/serve.vue